// ═══════════════════════════════════════════════════════════════
// useConfirm — boîte de dialogue de confirmation globale (remplace window.confirm)
// ═══════════════════════════════════════════════════════════════
// État réactif singleton consommé par `components/ui/ConfirmDialog.vue`
// (monté une fois dans App.vue). `confirm()` renvoie une Promise<boolean>.
//
// Usage :
//   const confirm = useConfirm();
//   if (!await confirm({ message: t('...'), variant: 'danger' })) return;
// ═══════════════════════════════════════════════════════════════

import { reactive } from 'vue';

const state = reactive({
  open: false,
  title: '',
  message: '',
  confirmLabel: '',
  cancelLabel: '',
  variant: 'primary', // 'primary' | 'danger'
});

let resolver = null;

function ask(opts = {}) {
  // Si une confirmation est déjà ouverte, on la résout en "annulé" avant.
  if (resolver) { resolver(false); resolver = null; }
  state.title = opts.title || '';
  state.message = opts.message || '';
  state.confirmLabel = opts.confirmLabel || '';
  state.cancelLabel = opts.cancelLabel || '';
  state.variant = opts.variant === 'danger' ? 'danger' : 'primary';
  state.open = true;
  return new Promise((resolve) => { resolver = resolve; });
}

function settle(value) {
  state.open = false;
  const r = resolver;
  resolver = null;
  if (r) r(value);
}

// Pour le composant hôte (ConfirmDialog.vue).
export const confirmState = state;
export const acceptConfirm = () => settle(true);
export const cancelConfirm = () => settle(false);

export function useConfirm() {
  return ask;
}
